import { useTranslation } from 'react-i18next';
import { ExternalScheduleMaterialInputsProps } from './types';
import { FormItemWrapper } from '@components/ui/form/itemWrapper';
import { Input } from '@components/ui/form/input';
import React from 'react';

export const ExternalScheduleMaterialInputs = ({
  material,
}: ExternalScheduleMaterialInputsProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'forms' });

  return (
    <div className="grid grid-cols-2 gap-4">
      {material?.options?.map((option) => {
        return (
          <React.Fragment key={option.id}>
            {option.includeEstimated && (
              <FormItemWrapper
                label={t('estimatedUnits.label', { name: option?.name, unit: option?.unit || '' })}>
                <Input value={option?.estimatedQuantity || ''} disabled readOnly />
              </FormItemWrapper>
            )}
            <FormItemWrapper
              label={t('finalUnits.label', { name: option?.name, unit: option?.unit || '' })}>
              <Input value={option?.finalQuantity || ''} disabled readOnly />
            </FormItemWrapper>
          </React.Fragment>
        );
      })}
    </div>
  );
};
